module.exports = __webpack_public_path__ + "static/reward2-title.ab6c2fd9.png";